import { Button, Grid, Typography } from "@mui/material";
import AdminField from "../../../layout/AdminField";
import VideogameAssetIcon from "@mui/icons-material/VideogameAsset";
import RefreshIcon from "@mui/icons-material/Refresh";

function ScreenStyleSettings(props: any) {
  const {
    tabValue,
    tabOrder,
    campaign,
    handleScreenStyleChange,
    handleSizeChange,
    handleShowGameScreen,
    openImagePicker,
    id,
    iframeSrc,
    isLoaded,
    iframeSize,
  } = props;

  return (
    <div
      role="tabpanel"
      hidden={tabValue !== tabOrder}
      id={`simple-tabpanel-${tabOrder}`}
      aria-labelledby={`simple-tab-${tabOrder}`}
    >
      <Typography variant="h5" gutterBottom sx={{ mb: 5 }}>
        Görselleştirme Ayarları
      </Typography>
      <Grid container spacing={6} sx={{ mb: 4 }}>
        <Grid item xs={6}>
          <Grid container spacing={4} sx={{ mb: 4 }}>
            <AdminField
              label="Ekran Tipi"
              type="radio"
              value={campaign.screenStyle.screenType || 1}
              helperText="Oyunun ne tip bir ekranda oynanacağını seçiniz. Standart seçeneği genellikle ekran tiplerine uyum sağlayacaktır. Uyumsuzluk gördüğünüzde kullanılacak ekran tipine göre bu alandan seçim yapınız."
              onChange={(value) => {
                const parsedValue = parseInt(value, 10);
                handleScreenStyleChange("screenType", parsedValue);
                handleSizeChange(parsedValue, true);
              }}
              selectOptions={[
                { label: "Standart", value: 1 },
                { label: "Kiosk Dik", value: 2 },
                { label: "Kiosk Geniş", value: 3 },
                { label: "Mobil", value: 4 },
                { label: "Tablet Dik", value: 5 },
                { label: "Tablet Geniş", value: 6 }
              ]}
            />
            <AdminField
              label="Oyun Üstten Boşluk"
              value={campaign.screenStyle.gameFromTop}
              type="number"
              onChange={(value) =>
                handleScreenStyleChange(
                  "gameFromTop",
                  value !== "" ? parseInt(value) : null
                )
              }
              helperText="Oyun alanının üstten boşluk değerini yüzde değeri olarak giriniz"
            />
            <AdminField
              label="Ekran Başlığı"
              value={campaign.screenStyle.pageTitle}
              onChange={(value) => handleScreenStyleChange("pageTitle", value)}
              helperText="Çarkıfelek ekranında yer alacak başlığı yazınız"
            />
            <AdminField
              label="Ekran Başlığı Üstten Boşluk"
              value={campaign.screenStyle.titleFromTop}
              type="number"
              onChange={(value) =>
                handleScreenStyleChange(
                  "titleFromTop",
                  value !== "" ? parseInt(value) : null
                )
              }
              helperText="Ekran başlığının üstten boşluk değerini rakam olarak giriniz"
            />
            <AdminField
              label="Ekran Başlığı Genişliği"
              value={campaign.screenStyle.titleWidth}
              type="number"
              onChange={(value) =>
                handleScreenStyleChange(
                  "titleWidth",
                  value !== "" ? parseInt(value) : null
                )
              }
              helperText="Ekran başlığının genişliğini yüzde değeri olarak giriniz"
            />
            <AdminField
              label="Ekran Başlığı Font Boyutu"
              value={campaign.screenStyle.titleFontSize}
              type="number"
              onChange={(value) =>
                handleScreenStyleChange(
                  "titleFontSize",
                  value !== "" ? parseInt(value) : null
                )
              }
              helperText="Ekran başlığının punto boyutunu rakam olarak giriniz"
            />
            <AdminField
              label="Ekran Mottosu"
              value={campaign.screenStyle.motto}
              onChange={(value) => handleScreenStyleChange("motto", value)}
              helperText="Çarkıfelek ekranı çark altında yer alacak motto yazısını yazınız"
            />
            <AdminField
              label="Ekran Logosu"
              value={campaign.screenStyle.logo}
              onChange={(value) => handleScreenStyleChange("logo", value)}
              helperText="Çarkıfelek ekranı çark üstünde yer alacak logoyu ekleyiniz"
              type="button"
              buttonText="Galeri'den Seç"
              onClick={() => openImagePicker("logo")}
            />
            <AdminField
              label="Ekran Logosu Üstten Boşluk"
              value={campaign.screenStyle.logoFromTop}
              type="number"
              onChange={(value) =>
                handleScreenStyleChange(
                  "logoFromTop",
                  value !== "" ? parseInt(value) : null
                )
              }
              helperText="Ekran logosunun üstten boşluk değerini rakam olarak giriniz"
            />
            <AdminField
              label="Ekran Logosu Yüksekliği"
              value={campaign.screenStyle.logoHeight}
              type="number"
              onChange={(value) =>
                handleScreenStyleChange(
                  "logoHeight",
                  value !== "" ? parseInt(value) : null
                )
              }
              helperText="Ekran logosunun yükseklik değerini rakam olarak giriniz. Genişliği orantılı olarak ayarlanacaktır."
            />
            <AdminField
              label="Ekran Arkaplan Görseli"
              value={campaign.screenStyle.screenBg}
              onChange={(value) => handleScreenStyleChange("screenBg", value)}
              helperText="Çarkıfelek ekranı arkaplan desen görselini yükleyiniz"
              type="button"
              buttonText="Galeri'den Seç"
              onClick={() => openImagePicker("screenBg")}
            />
            <AdminField
              label="Oyun Altı Ek Görseli"
              value={campaign.screenStyle.screenCenterBg}
              onChange={(value) =>
                handleScreenStyleChange("screenCenterBg", value)
              }
              helperText="Oyunun altında ortada yer alacak ek görseli yükleyiniz"
              type="button"
              buttonText="Galeri'den Seç"
              onClick={() => openImagePicker("screenCenterBg")}
            />
            <AdminField
              label="Oyun Altı Ek Görseli Üstten Boşluk"
              value={campaign.screenStyle.screenCenterBgFromTop}
              type="number"
              onChange={(value) =>
                handleScreenStyleChange(
                  "screenCenterBgFromTop",
                  value !== "" ? parseInt(value) : null
                )
              }
              helperText="Oyunun altında yer alacak ek görselin üstten boşluk değerini rakam olarak giriniz"
            />
            <AdminField
              label="Ekran Arkaplan Rengi"
              type="color"
              inline
              inlineFix={4}
              value={campaign.screenStyle.screenColor}
              onChange={(value) =>
                handleScreenStyleChange("screenColor", value)
              }
              helperText="Çarkıfelek ekranı arkaplan rengini seçiniz"
            />
            <AdminField
              label="Ekran Yazı Rengi"
              type="color"
              inline
              value={campaign.screenStyle.textColor}
              onChange={(value) => handleScreenStyleChange("textColor", value)}
              helperText="Çarkıfelek ekranı yazı rengini seçiniz"
            />
          </Grid>
        </Grid>
        <Grid item xs={6} className="center-inside">
          {id && (
            <>
              <Typography variant="h6" gutterBottom>
                Oyun Ekranı Önizleme
              </Typography>
              <AdminField
                type="radio"
                value={iframeSize.width === 360 ? "9:16" : "16:9"}
                onChange={handleSizeChange}
                selectOptions={[
                  { label: "9:16 (1080x1920)", value: "9:16" },
                  { label: "16:9 (1920x1080)", value: "16:9" },
                ]}
              />
              <Button
                variant="contained"
                color="warning"
                name="showGameScreen"
                onClick={handleShowGameScreen}
                startIcon={isLoaded ? <RefreshIcon /> : <VideogameAssetIcon />}
                sx={{ my: 3 }}
              >
                {isLoaded
                  ? "Kaydet ve Oyun Ekranını Yenile"
                  : "Kaydet ve Oyun Ekranını Göster"}
              </Button>
              <br />
              {iframeSrc ? (
                <div
                  id={
                    iframeSize.width === 360
                      ? "game-preview-portrait"
                      : "game-preview-landscape"
                  }
                >
                  <iframe
                    width={iframeSize.width}
                    height={iframeSize.height}
                    src={iframeSrc}
                    title="Game Screen"
                    style={{ border: "2px solid #e0e0e0" }}
                  />
                </div>
              ) : (
                <div
                  style={{
                    width: iframeSize.width,
                    height: iframeSize.height,
                    backgroundColor: "#e0e0e0",
                    textAlign: "center",
                    lineHeight: `${iframeSize.height}px`,
                  }}
                >
                  <span>Oyun ekranını buradan inceleyebilirsiniz</span>
                </div>
              )}
            </>
          )}
        </Grid>
      </Grid>
    </div>
  );
}

export default ScreenStyleSettings;
